module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921045649_T.eb7b9ca4.jpg";